module.exports = "#cor1,#cor2,#cor3 {\n    width:20px;\n    height: 20px;\n}"